import { SAVE_USER_DATA_LAMBDA_URL } from 'src/utils/const';
import { callApi } from 'src/core/callApi';
import { updateUserExplorerPageRowDataExportUsageAction } from 'src/store/Dashboard/actions';

export const updateUserExplorerPageRowDataExportUsage = async (creditsUsed: number, dispatch: any) => {
  try {
    const success = await callApi(
      SAVE_USER_DATA_LAMBDA_URL,
      {
        body: {
          marketExplorerRowDataExportUsage: creditsUsed,
        },
      },
      true,
      false,
      '',
      'POST',
      true
    );
    console.log(success);

    if (success && success.user_data_updated) {
      dispatch(updateUserExplorerPageRowDataExportUsageAction(creditsUsed));
    }
  } catch (err) {
    console.error(err);
  }
};
